import {Defaultable} from 'Core/models/Default';
import {EmptyString, eqStringUnion, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {Validatable} from 'Core/models/Valid';
import {getEq} from 'fp-ts/lib/Array';
import * as E from 'fp-ts/lib/Either';
import {Eq, getStructEq} from 'fp-ts/lib/Eq';

export type RecruiterCode = Validatable<Defaultable<InvalidRecruiterCode>, ValidRecruiterCode>;

export type InvalidRecruiterCode = {
  code: StringUnion;
};

export class ValidRecruiterCode {
  public static create(code: StringUnion): RecruiterCode {
    return code instanceof NonEmptyString && code.value.length === 5
      ? E.right(new ValidRecruiterCode(code))
      : E.left(E.right({code}));
  }

  private constructor(public readonly code: NonEmptyString) {}
}

export const EmptyRecruiterCode: RecruiterCode = E.left(
  E.left({
    code: new EmptyString(),
  })
);

export const isValidRecruiterCode = (recruiterCode: RecruiterCode): recruiterCode is E.Right<ValidRecruiterCode> =>
  E.isRight(recruiterCode);

export const validateRecruiterCode = (recruiterCode: InvalidRecruiterCode | ValidRecruiterCode) =>
  ValidRecruiterCode.create(recruiterCode.code);

export const eqRecruiterCode: Eq<InvalidRecruiterCode | ValidRecruiterCode> = getStructEq({
  code: eqStringUnion,
});

export const eqArrayOfRecruiterCodes = getEq(eqRecruiterCode);
